import request from '@/utils/request'

export const getCaptcha = () => {
  return request.get('/captcha')
}

export const getRegisterVerifyCode = (data) => {
  return request.post('/user/send-verification-code', { ...data, code_type: 'register' })
}

export const register = (data) => {
  return request.post('/user/register', { ...data })
}

export const login = (data) => {
  return request.post('/user/login', { ...data })
}

export const getUserInfoDetail = () => {
  return request.get('user/current-user')
}
